import {DotPath} from '../getOrElse'
import {getDefinedOrElse} from './getter'
import {Decorators} from '../config/getterConfig'
import {decorate} from './decorator'

export function dateOr<R extends any, T extends Date>(
  root: R,
  path: DotPath = '',
  decorators: Decorators<T> = [],
  orElse = new Date() as T
): T {
  /*
   * try/catch left to be compatible with some ES versions.  Post ES5
   * will no longer thrown an exception for non-date strings but instead
   * returns an 'Invalid Date'
   *
   * See https://stackoverflow.com/questions/1353684/detecting-an-invalid-date-date-instance-in-javascript
   *
   */
  try {
    return [].concat(
      new Date(
        decorate(
          getDefinedOrElse(root, path, orElse),
          decorators
        )
      )
    ).map(
      possibleDate =>
        (!isNaN(possibleDate.getTime())) ?
          possibleDate : orElse
    ).shift() as T
  }
  catch (e) { return orElse }
}